import RestaurantListItem from './item';

export { type RestaurantListItemProps } from './item';

export default RestaurantListItem;
